jQuery(document).ready(function($) {

	var throttle = require('lodash.throttle');
	var debounce = require('lodash.debounce');
	var imagesLoaded = require('imagesloaded');

	var //$body = $('body'),
		$window = $(window),
		windowHeight,
		scrollTop = 0,
		workSection = $( '#work' ),
		workSectionBottom = 0,
		workSectionNav = $( '[data-nav-for="#work"]' ),
		aboutSection = $( '#about-and-contact' ),
		aboutSectionTop = 0,
		aboutSectionNav = $( '[data-nav-for="#about-and-contact"]' )
		;

	function init() {

		// Event Listeners
		$window.on('scroll.ScrollThemeThrottled', throttle(scrollUpdate, 150));
		$window.on('resize.ScrollTheme', debounce(updatePage, 300));

        imagesLoaded( $( 'body' ), function() {
			updatePage();
		});

		$('video').load( function () {
			updatePage();
		});

		// Initial calculation
		updatePage();
		scrollUpdate();
	}

	function scrollUpdate() {

		// Get current scroll position
		scrollTop = $window.scrollTop();

		// console.log( 'scrollTop: ', scrollTop, 'windowHeight: ', windowHeight, 'scrollTop + 1 / 2 * windowHeight', scrollTop + 1 / 2 * windowHeight, 'aboutSectionTop: ', aboutSectionTop );


		// current class, used for mobile
		if( scrollTop + 1 / 2 * windowHeight > aboutSectionTop ) {
			aboutSectionNav.addClass( 'current' );
			workSectionNav.removeClass( 'current' );
		} else {
			aboutSectionNav.removeClass( 'current' );
			workSectionNav.addClass( 'current' );
		}

		// show or hide, for desktop
		if( scrollTop + 1 / 6 * windowHeight >= workSectionBottom ) {
			workSectionNav.addClass( 'show' );
			// console.log( 'scrollTop >= workSectionBottom' );
		} else {
			workSectionNav.removeClass( 'show' );
			// console.log( 'NOT scrollTop >= workSectionBottom' );
		}

		if( scrollTop + windowHeight <= aboutSectionTop ) {
			aboutSectionNav.addClass( 'show' );
			// console.log( 'scrollTop + windowHeight <= aboutSectionTop' );
		} else {
			aboutSectionNav.removeClass( 'show' );
			// console.log( 'NOT scrollTop + windowHeight <= aboutSectionTop' );
		}

	}

	function updatePage() {
		workSectionBottom = workSection.offset().top + workSection.outerHeight();

		aboutSectionTop = aboutSection.offset().top;

		windowHeight = $window.outerHeight(); // Get current window height

		scrollUpdate();

	}

	init();

});